exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[view=\"app\"] .page-container {\n  display: inline-block;\n  width: 400px;\n  margin-top: calc(50vh - 207px);\n  margin-left: calc(50% - 240px - 200px);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e7f006c","scoped":false,"hasInlineConfig":false}!../node_modules/sass-loader/lib/loader.js!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/App.vue
// module id = 421
// module chunks = 0